import { isTextNode, isWidgetNode } from '@creative/nodes/helpers';
import { FeedType, IFeed, IVariable, IVersionProperty, IWidgetElementProperty, OneOfElementDataNodes } from '@studio/domain';
import { IElementProperty } from '@studio/domain/creativeset/element';
import { isVariableSpan } from '../rich-text/text-nodes';

export function encodeFeedPath(path: string): string {
    return path.replace(/\s/g, '%20');
}

export function decodeFeedPath(path: string): string {
    return path.replace(/%20/g, ' ');
}

export function createFeed(id: string, path: string = '', type: FeedType = 'text'): IFeed {
    const feed: IFeed = {
        id: id,
        path: encodeFeedPath(path ?? ''),
        step: {
            occurrence: 'loop',
            size: 1,
            start: 1
        },
        fallback: '',
        type: type
    };
    return feed;
}

export function createVariable(id: string, path: string = ''): IVariable {
    return { ...createFeed(id, path, 'text'), type: 'text' };
}

export function isFeedValue(value: any): value is IFeed {
    if (typeof value !== 'object') {
        return false;
    }

    if ('id' in value && 'path' in value && 'step' in value) {
        return true;
    }

    return false;
}

export function isVersionedFeed(property: IVersionProperty | IElementProperty | IWidgetElementProperty): property is IVersionProperty<IFeed> {
    if (isFeedValue(property.value)) {
        return true;
    }

    return false;
}

export function hasFeededContent(element: OneOfElementDataNodes): boolean {
    if (element.feed) {
        return true;
    }

    if (isTextNode(element)) {
        const content = element.__dirtyContent?.spans || element.content.spans;
        for (const span of content) {
            if (isVariableSpan(span)) {
                return true;
            }
        }
    }

    if (isWidgetNode(element)) {
        for (const property of element.customProperties) {
            // using deserializePropertyValue here would be better, but increases bundle size by a lot
            if (property.unit === 'feed' && JSON.parse(property.value as string).id) {
                return true;
            }
        }
    }

    return false;
}

export function isFeedpathProperty(property: Omit<IElementProperty, 'id'>): boolean {
    return property.name.indexOf('feedPath') > -1;
}
